import React from "react";
import * as Yup from "yup";

import Form from "@Components/Form";
import { URLS } from "configs/constants";
import { useTranslation } from "react-i18next";


let API_URL = "user-contract/";

const SUPPORTING_DOCUMENT_FORMATS = [
  "image/jpg",
  "image/jpeg",
  "image/gif",
  "image/png",
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];



const validationSchema = Yup.object({
  language: Yup.string()
    .required("Language is required")
    .typeError("Invalid language"),
  nationality: Yup.string()
    .required("Nationality is required")
    .typeError("Invalid nationality"),
  contract_file: Yup.mixed().test(
    "fileType",
    "Unsupported file type",
    (value) => {
      if (value === null) {
        return true;
      } else if (typeof value === "string") {
        return true;
      } else {
        return SUPPORTING_DOCUMENT_FORMATS.includes(value.type);
      }
    }
  ),
});
const ContractUpload = () => {
 
 

  const { t } = useTranslation();

  const initialValues = {
    language: "",
    is_default: true,
    status: false,
    nationality: "",
    contract_file: null,
  };

  
  const formFields = [
    { type: "title", title: "Worker Contract T&C" },
    {
      type: "renderonly",
      name: "language",
      key: "language",
      label: "Document Language",
      required: true,
    },
    {
      type: "renderonly",
      name: "is_default",
      label: "Default",
      key: "is_default",
      valueType: "boolean",
      yesValue: "Yes",
      noValue: "No",
      
    },
    {
      type: "renderonly",
      name: "status",
      key:"status",
      label: "Status",
      required: true,
    },
    {
      type: "renderonly",
      name: "parsed_nationality",
      label: "Nationality",
      key: "parsed_nationality",
      required: true,
    },
    {
      type: "filedownload",
      name: "contract_file",
      label: "Contract T&C",
      supportedTypes: [t("pdf format only")],
      required: true,
    },
  ];

  const formButtons = ["cancel"];
  return (
    <Form
      initialValues={initialValues}
      validationSchema={validationSchema}
      submitUrl={API_URL}
      listRoute={URLS.WORKER_CONTRACT_LIST}
      formFields={formFields}
      formButtons={formButtons}
      isMultipart
      formTitle="Worker Contract Upload"
    />
  );
};

export default ContractUpload;
